import { Image } from "lucide-react";
import { ServiceImage } from "@/types/user";

interface GallerySectionProps {
  gallery?: ServiceImage[];
}

export function GallerySection({ gallery }: GallerySectionProps) {
  if (!gallery?.length) return null;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Image className="h-5 w-5" />
        <h2 className="text-xl font-semibold">Galeria de Serviços</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {gallery.map((image) => (
          <div key={image.id} className="relative aspect-square group">
            <img
              src={image.url}
              alt={image.description}
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
              <p className="text-white text-sm p-2 text-center">
                {image.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}